<template>
  <div class="bylaws-container">
    <div class="block-title">章程</div>

    <div class="img-block">
      <img src="~@/assets/z-1.png" alt="">
    </div>
    <div class="img-block">
      <img src="~@/assets/z-2.png" alt="">
    </div>
    <div class="img-block">
      <img src="~@/assets/z-3.png" alt="">
    </div>
    <div class="img-block">
      <img src="~@/assets/z-4.png" alt="">
    </div>
    <div class="img-block">
      <img src="~@/assets/z-5.png" alt="">
    </div>
    <div class="img-block">
      <img src="~@/assets/z-6.png" alt="">
    </div>
    <div class="img-block">
      <img src="~@/assets/z-7.png" alt="">
    </div>
    <div class="img-block">
      <img src="~@/assets/z-8.png" alt="">
    </div>
    <div class="img-block">
      <img src="~@/assets/z-9.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  },
  created() {

  }
}
</script>

<style lang="scss">
.bylaws-container {

}
</style>
